module.exports = __webpack_public_path__ + "static/media/emoticon-emotion-expression-face-smiley-2-svgrepo-com.094f13bb.svg";